{
  "dashboard": {
    "welcomeBack": "歡迎回來",
    "subtitle": "您的即時拍賣控制中心。一站式追蹤出價、追蹤清單同付款。",
    "sellerDashboardBtn": "賣家儀表板",
    "listCardBtn": "刊登卡片",
    "stat": {
      "leadingLabel": "目前領先",
      "leadingHint": "您正在領先嘅即時拍賣",
      "outbidLabel": "被超價",
      "outbidHint": "需要重新出價嘅即時拍賣",
      "wonLabel": "已投得拍賣",
      "wonHint": "已完成嘅投得項目",
      "watchlistLabel": "追蹤清單",
      "watchlistHint": "您正在追蹤嘅卡片"
    },
    "summary": {
      "pendingPaymentsLabel": "待付款",
      "pendingPaymentsHint": "等待結帳嘅訂單",
      "totalSpendLabel": "總消費",
      "totalSpendHint": "已付款訂單總額",
      "ordersLabel": "訂單",
      "ordersHint": "歷來訂單紀錄",
      "listingsLabel": "我嘅刊登",
      "listingsHint": "您已刊登嘅卡片"
    },
    "pendingBanner": "{count, plural, other {您有 # 張訂單待付款。}}",
    "completePayment": "完成付款",
    "leadingListTitle": "您正領先嘅拍賣",
    "leadingListEmpty": "目前冇任何即時拍賣您係最高出價者。",
    "outbidListTitle": "您已被超價",
    "outbidListEmpty": "冇被超價嘅拍賣——保持得好。",
    "watchlistListTitle": "追蹤清單",
    "watchlistListEmpty": "您嘅追蹤清單係空嘅。",
    "viewAll": "查看全部",
    "quickLink": {
      "sellerTitle": "賣家儀表板",
      "sellerHint": "銷售、收益、付款同表現",
      "myBidsTitle": "我嘅出價",
      "myBidsHint": "追蹤您嘅活動",
      "watchlistTitle": "追蹤清單",
      "watchlistHint": "您正在追蹤嘅卡片"
    }
  },
  "sidebar": {
    "buyingGroup": "買家",
    "dashboard": "儀表板",
    "browseAuctions": "瀏覽拍賣",
    "watchlist": "追蹤清單",
    "myBids": "我嘅出價",
    "wonOrders": "投得同訂單",
    "sellingGroup": "賣家",
    "sellerDashboard": "賣家儀表板",
    "myAuctions": "我嘅拍賣",
    "listCard": "刊登卡片",
    "payouts": "付款",
    "accountGroup": "帳戶",
    "notifications": "通知",
    "settings": "設定",
    "adminGroup": "管理",
    "admin": "管理",
    "signOut": "登出"
  },
  "billing": {
    "eyebrow": "賣家",
    "title": "費用與付款",
    "subtitle": "BidNova 只收取簡單嘅 8% 成交佣金,只在成功售出時收取。冇月費、冇訂閱費、冇刊登費。",
    "included": {
      "noListingFees": "冇刊登費",
      "noMonthlyFees": "冇月費",
      "noSubscriptionFees": "冇訂閱費",
      "commissionOnly": "只在成功售出時收取佣金",
      "securePayouts": "以英鎊安全透過 Stripe 付款",
      "buyerProtection": "包含買家保障及爭議處理"
    },
    "commissionTitle": "賣家佣金",
    "commissionBadge": "統一 8%",
    "commissionDesc": "只在您嘅物品售出時收取。",
    "howTitle": "付款計算方式",
    "howDesc": "每張訂單都清晰列明明細。",
    "formula": "賣家收款 = 最終成交價 − 8% BidNova 佣金",
    "bullet1": "買家需支付全部得標價加上您所設定嘅運費。",
    "bullet2": "BidNova 會從物品總額(不包括運費)中扣除 8% 佣金。",
    "bullet3": "確認送達及爭議期過後,餘額會存入您已連結嘅 Stripe 帳戶。",
    "bullet4": "Stripe 交易處理費用可能適用,並會顯示喺每張訂單上。",
    "exampleTitle": "示例",
    "exampleFinalPrice": "最終成交價",
    "exampleCommission": "BidNova 佣金 (8%)",
    "examplePayout": "賣家收款"
  },
  "scanHistory": {
    "eyebrow": "AI 掃描器",
    "title": "掃描紀錄",
    "subtitle": "您所有進行過嘅掃描,包括識別出嘅卡片、信心值、狀況建議同任何真偽提示。",
    "newListing": "新增刊登",
    "loading": "載入中…",
    "empty": "仲未有任何掃描紀錄。開始刊登以 AI 掃描您第一張卡片。",
    "conditionFallback": "狀況 —",
    "verifyBadge": "需核實",
    "confirmedBadge": "已確認",
    "deleteConfirm": "刪除呢個掃描紀錄?此操作無法還原。",
    "deleteSuccess": "掃描紀錄已刪除",
    "duplicateBtn": "複製"
  },
  "shipping": {
    "backToSeller": "返回賣家儀表板",
    "eyebrow": "運送",
    "title": "運送偏好設定",
    "subtitle": "管理您喺 BidNova 刊登所用嘅運送選項。您毋須連結 Royal Mail 亦可以喺 BidNova 出售。",
    "loading": "正在載入您嘅運送偏好設定…",
    "prefsHeading": "您嘅運送偏好設定",
    "prefsDesc": "設定建立新刊登時所用嘅預設包裹同服務。",
    "noteOptional": "Royal Mail Click & Drop 屬於選用功能。賣家刊登時可選用任何支援嘅運送服務。",
    "preferredService": "偏好運送服務",
    "preferredServiceHelp": "作為新刊登嘅預設值,您可以就個別刊登更改。",
    "defaultWeight": "預設包裹重量(克)",
    "defaultFormat": "預設包裹類型",
    "futureHeading": "更多設定即將推出",
    "futureDispatch": "發貨時間(售出後幾快寄出)",
    "futureDomestic": "本地運送偏好",
    "futureCollection": "自取偏好",
    "futureNote": "呢啲選項暫時未推出。請暫時喺每個刊登描述中列明您嘅發貨預期。",
    "senderHeading": "寄件人 / 退回資料",
    "senderDesc": "適用時會用喺運送標籤及退回地址。",
    "senderName": "商號 / 寄件人名稱",
    "senderEmail": "聯絡電郵",
    "senderPhone": "聯絡電話",
    "senderLine1": "地址第一行",
    "senderLine2": "地址第二行",
    "senderCity": "城市",
    "senderCounty": "郡/地區",
    "senderPostcode": "郵政編碼",
    "senderCountry": "國家",
    "savePreferences": "儲存偏好設定",
    "saveSuccess": "運送偏好設定已儲存",
    "saveError": "未能儲存您嘅運送偏好設定,請重試。",
    "advancedHeading": "進階運送整合",
    "advancedDesc": "選用功能。連結第三方寄件帳戶以整合標籤生成。",
    "royalMailTitle": "Royal Mail Click & Drop",
    "royalMailDesc": "連結您嘅 Royal Mail Click & Drop 帳戶,直接喺 BidNova 生成運送標籤。運送標籤費用會直接向您嘅 Royal Mail 帳戶收取。BidNova 不會收取或保存 Royal Mail 郵費。",
    "royalMailOptionalNote": "此整合功能屬選用,適合已使用 Royal Mail Click & Drop 嘅賣家。",
    "statusConnected": "已連結",
    "statusUnsuccessful": "連結失敗",
    "statusNotConnected": "未連結",
    "connectedMessage": "您嘅 Royal Mail Click & Drop 帳戶已連結。",
    "onFile": "已存檔",
    "lastChecked": "上次檢查",
    "testConnection": "測試連線",
    "disconnect": "取消連結",
    "connectSuccess": "已連結 Royal Mail Click & Drop",
    "connectErrorTitle": "連結失敗",
    "connectErrorDesc": "未能驗證您嘅 Royal Mail Click & Drop 帳戶,請檢查 API 密鑰後重試。",
    "testSuccess": "Royal Mail 連線有效",
    "disconnectSuccess": "已取消連結 Royal Mail",
    "disconnectError": "未能取消連結 Royal Mail,請重試。",
    "invalidTitle": "連結失敗",
    "invalidDesc": "未能驗證您嘅 Royal Mail Click & Drop 帳戶,請檢查 API 密鑰後重試。",
    "notConnectedNote": "毋須連結 Royal Mail 您亦可以喺 BidNova 出售。只有想整合標籤生成先需要連結 Click & Drop。",
    "apiKeyLabel": "Royal Mail Click & Drop API 密鑰",
    "apiKeyHelp": "您嘅 API 密鑰會加密儲存,儲存後不會完整顯示。",
    "connectVerify": "連結並驗證",
    "connecting": "連結中…",
    "disconnectDialogTitle": "取消連結 Royal Mail?",
    "disconnectDialogDesc": "取消連結後 BidNova 將無法生成 Royal Mail 標籤。現有標籤同過往訂單不受影響。",
    "cancel": "取消"
  },
  "shipped": {
    "eyebrow": "賣家",
    "title": "已寄出紀錄",
    "subtitle": "追蹤過往嘅寄件、送達結果同退貨。僅供查閱。",
    "backToDashboard": "返回儀表板",
    "tabShipped": "已寄出訂單",
    "tabDelivered": "已送達",
    "tabCancelled": "已取消",
    "tabReturned": "已退回",
    "searchPlaceholder": "以買家、拍賣標題或追蹤編號搜尋…",
    "searchAriaLabel": "搜尋已寄出訂單",
    "filterBuyer": "買家",
    "filterBuyerPlaceholder": "買家名稱",
    "filterTracking": "追蹤編號",
    "filterTrackingPlaceholder": "Royal Mail 追蹤",
    "filterAuction": "拍賣",
    "filterAuctionPlaceholder": "拍賣標題",
    "filterFrom": "由",
    "filterTo": "至",
    "resultsCount": "{count, plural, other {# 個結果}}",
    "clearFilters": "清除篩選",
    "refresh": "重新整理",
    "colOrder": "訂單",
    "colAuction": "拍賣",
    "colBuyer": "買家",
    "colTracking": "追蹤",
    "colService": "服務",
    "colRoyalMail": "Royal Mail",
    "colDispatched": "已發送",
    "colDelivered": "已送達",
    "colTotal": "總計",
    "colStatus": "狀態",
    "colActions": "操作",
    "loadError": "無法載入已寄出紀錄。",
    "retry": "重試",
    "noMatches": "冇符合嘅訂單。",
    "pageOf": "第 {page} / {totalPages} 頁",
    "previous": "上一頁",
    "next": "下一頁",
    "viewOrder": "查看訂單",
    "copyTracking": "複製追蹤編號",
    "copyTrackingSuccess": "已複製追蹤編號。",
    "copyTrackingError": "無法複製追蹤編號。",
    "downloadLabel": "下載運送標籤",
    "labelUnavailable": "標籤不可用。",
    "trackAria": "喺 Royal Mail 追蹤 {tracking}",
    "statusLabelCreated": "標籤已建立",
    "statusDispatched": "已發送",
    "statusInTransit": "運送中",
    "statusDelivered": "已送達",
    "statusDeliveryAttempted": "曾嘗試派送",
    "statusCancelled": "已取消",
    "statusReturned": "已退回",
    "orderStatusShipped": "已寄出",
    "orderStatusDelivered": "已送達",
    "orderStatusReleased": "已完成",
    "orderStatusCancelled": "已取消",
    "orderStatusRefunded": "已退款"
  },
  "sellerIndex": {
    "eyebrow": "賣家",
    "title": "儀表板",
    "subtitle": "喺同一個地方管理您嘅刊登、銷售、付款同表現。",
    "shippedHistoryBtn": "寄出紀錄",
    "shippingSettingsBtn": "運送設定",
    "tabOverview": "概覽",
    "tabStripe": "Stripe",
    "tabAuctions": "拍賣",
    "tabFulfilment": "訂單處理",
    "tabSales": "銷售",
    "tabEarnings": "收益",
    "tabPerformance": "表現",
    "tabAnalytics": "分析",
    "tabPortfolio": "作品集",
    "tabNotifications": "通知",
    "kpi": {
      "totalSales": "總銷售額",
      "totalSalesHint": "已付款+已寄出+已送達+已釋放",
      "auctionRevenue": "拍賣收益",
      "auctionRevenueHint": "來自拍賣得標嘅銷售",
      "binRevenue": "即買即用收益",
      "binRevenueHint": "{count, plural, other {# 張即買即用訂單}}",
      "binConversionRate": "即買即用轉換率",
      "binConversionHint": "{sold} 售出 / {listings} 刊登",
      "binAvgPrice": "即買即用平均價格",
      "binAvgPriceHint": "即買即用平均售價",
      "activeBinListings": "進行中即買即用刊登",
      "activeBinListingsHint": "目前可供即買即用",
      "expiredBinListings": "已過期即買即用刊登",
      "expiredBinListingsHint": "已啟用即買即用但已結束或售出",
      "reservationsExpired": "已過期預留",
      "reservationsExpiredHint": "即買即用結帳已放棄",
      "netEarnings": "淨收益",
      "netEarningsHint": "扣除 8% 平台費用後",
      "heldBalance": "凍結餘額",
      "heldBalanceHint": "等待確認送達",
      "availablePayout": "可提取金額",
      "availablePayoutHint": "已釋放至您嘅 Stripe 帳戶",
      "platformFees": "平台費用",
      "activeAuctions": "進行中拍賣",
      "totalWatchers": "總追蹤人數",
      "totalWatchersHint": "來自您進行中拍賣嘅總數",
      "endingSoon": "24 小時內結束",
      "pendingApproval": "待批核",
      "pendingApprovalHint": "等待版主審核",
      "rejected": "已拒絕",
      "awaitingShipment": "待寄出",
      "awaitingShipmentHint": "準備寄出",
      "completedOrders": "已完成訂單"
    },
    "refresh": "重新整理",
    "monthlySales": "每月銷售額",
    "monthlySalesEmpty": "仲未有銷售紀錄——您第一張訂單會顯示喺呢度。",
    "salesTooltipLabel": "銷售",
    "recentActivity": "最近活動",
    "recentActivityEmpty": "仲未有任何活動。",
    "stripeAccountTitle": "Stripe Express 帳戶",
    "connectedAccount": "已連結帳戶",
    "openExpressDashboard": "開啟 Stripe Express 儀表板",
    "finishOnboarding": "請完成 Stripe 開戶程序,以開啟您嘅 Express 儀表板並接收付款。",
    "yourAuctions": "您嘅拍賣",
    "yourAuctionsDesc": "管理刊登、編輯未出價欄位、取消或重新刊登已結束項目。",
    "openAuctionsManager": "開啟拍賣管理",
    "listNewCard": "刊登新卡片",
    "filteredByStatus": "以狀態篩選:",
    "clearFilter": "清除篩選",
    "bidLockNote": "一旦拍賣已有出價,就只可編輯描述同相片——價格同結束時間會被鎖定。",
    "colAuction": "拍賣",
    "colStatus": "狀態",
    "colEnds": "結束時間",
    "colBids": "出價",
    "colWatchers": "追蹤人數",
    "colHighestBid": "最高出價",
    "colListed": "刊登時間",
    "sortByAria": "按{label}排序",
    "loading": "載入中…",
    "noListings": "仲未有任何刊登。",
    "ended": "已結束",
    "salesShipping": "銷售同運送",
    "salesShippingDesc": "完整訂單流程:已付款 → 準備中 → 已匯出至 Click & Drop → 已寄出 → 已送達 → 已釋放付款。批量 CSV 匯出、標記為已寄出並附追蹤編號,以及 Royal Mail 連結全部都喺訂單工作區入面。",
    "openOrdersWorkspace": "開啟訂單工作區",
    "salesPipeline": "銷售流程",
    "salesPipelineDesc": "點擊任何階段以喺訂單工作區查看相應訂單。",
    "stageAwaitingPayment": "待付款",
    "stagePaid": "已付款",
    "stageReadyToShip": "準備寄出",
    "stageShipped": "已寄出",
    "stageDelivered": "已送達",
    "stageReleased": "已釋放",
    "tileGrossSales": "總銷售額",
    "tilePlatformFees": "平台費用",
    "tileShippingReceived": "已收運費",
    "tileRefunds": "退款",
    "tileNetEarnings": "淨收益",
    "tileHeldBalance": "凍結餘額",
    "tileReleasedPayout": "已釋放付款",
    "tileActiveDisputes": "進行中爭議",
    "nextExpectedPayout": "下次預計付款",
    "ordersPendingRelease": "{count, plural, other {# 張訂單待釋放}}",
    "showingPendingHint": "正顯示待付款項目——點擊以顯示已釋放項目",
    "clickToViewIncluded": "點擊以查看包含嘅訂單",
    "pendingPayoutsTitle": "待付款項目",
    "payoutHistoryTitle": "付款紀錄",
    "downloadCsv": "下載 CSV 結單",
    "noPendingPayouts": "冇待付款項目。",
    "noReleasedPayouts": "仲未釋放任何付款。",
    "colOrderDate": "訂單日期",
    "colDate": "日期",
    "colAmount": "金額",
    "colReference": "參考編號",
    "csvOrder": "訂單",
    "csvAuction": "拍賣",
    "csvDate": "日期",
    "csvStatus": "狀態",
    "csvGross": "總額",
    "csvFee": "費用",
    "csvShipping": "運費",
    "csvNet": "淨額",
    "csvReleased": "已釋放",
    "csvReference": "參考編號",
    "sellerStatus": "賣家狀態",
    "perfCompletedSales": "已完成銷售",
    "perfCancellationRate": "取消率",
    "perfLateShipments": "延遲寄出 (>72 小時)",
    "perfAvgDispatch": "平均發貨時間",
    "perfDeliveryConfirmed": "已確認送達",
    "perfOpenDisputes": "進行中爭議",
    "perfAccountWarnings": "帳戶警告",
    "feedbackNote": "評分——買家評分功能即將推出。您上面嘅發貨速度同送達確認率已經影響緊您嘅賣家信譽。",
    "sellerNotifications": "賣家通知",
    "markAllRead": "全部標記為已讀",
    "allCaughtUp": "您已查看晒所有通知。",
    "somethingWrong": "發生錯誤",
    "retry": "重試"
  },
  "profile": {
    "eyebrow": "帳戶",
    "title": "帳戶與個人檔案",
    "subtitle": "您嘅登入電郵地址將保持私隱,不會顯示喺您嘅公開賣家檔案上。",
    "privateHeading": "私隱帳戶資料",
    "privateDesc": "只有您本人可以查看,不會喺公開頁面顯示。",
    "loginEmail": "登入電郵",
    "emailVerified": "電郵已驗證",
    "verifiedYes": "係",
    "verifiedNo": "尚未驗證",
    "changePassword": "更改密碼",
    "publicHeading": "公開檔案",
    "avatarLabel": "頭像或店舖標誌",
    "avatarHelp": "JPG、PNG 或 WebP・最多 5 MB。",
    "uploading": "上載中…",
    "uploadImage": "上載圖片",
    "remove": "移除",
    "displayName": "顯示名稱",
    "displayNameHelp": "您嘅公開個人或社群名稱。",
    "username": "用戶名",
    "usernameHelp": "3–30 個字元,小寫字母、數字、連字號。用喺您嘅公開網址:",
    "usernameChangeNote": "用戶名每 30 日只可以更改一次。",
    "checkingAvailability": "正在檢查可用性…",
    "usernameCurrent": "呢個係您目前嘅用戶名。",
    "usernameAvailable": "呢個用戶名可以使用。",
    "shopName": "店舖名稱",
    "shopNamePlaceholder": "選填 — 例如 Double Blessings TCG",
    "shopNameHelp": "設定後會顯示畀買家,取代您嘅顯示名稱。",
    "bio": "簡介",
    "bioPlaceholder": "簡短嘅公開自我介紹。只限純文字。",
    "location": "公開地點",
    "locationPlaceholder": "例如:Manchester, United Kingdom",
    "locationHelp": "請勿輸入您完整嘅住址。呢項資料可能會公開顯示。",
    "coverImage": "封面圖片",
    "coverImageHelp": "顯示喺您公開賣家頁面頂部嘅橫幅。JPG、PNG 或 WebP・最多 5 MB。",
    "noCoverImage": "仲未有封面圖片",
    "uploadCover": "上載封面",
    "replaceCover": "更換封面",
    "website": "網站",
    "socialTwitter": "Twitter / X",
    "socialInstagram": "Instagram",
    "socialFacebook": "Facebook",
    "socialYoutube": "YouTube",
    "socialTiktok": "TikTok",
    "socialDiscord": "Discord",
    "publicSellerProfile": "公開賣家檔案",
    "publicSellerProfileDesc": "開啟後,買家可以喺以下網址瀏覽您嘅賣家頁面:",
    "publicPreview": "公開預覽",
    "saving": "儲存中…",
    "saveProfile": "儲存檔案",
    "toastProfileUpdated": "您嘅公開檔案已更新。",
    "toastSaveFailed": "未能儲存檔案。",
    "toastInvalidImage": "請選擇 JPG、PNG 或 WebP 格式嘅圖片。",
    "toastImageTooLarge": "圖片大小必須為 5 MB 或以下。",
    "toastCoverReady": "封面已準備好。儲存您嘅檔案以發佈。",
    "toastUploadFailed": "上載失敗。",
    "toastAvatarReady": "頭像已準備好。儲存您嘅檔案以發佈。"
  }
}
